<div class="hf-benefits-wrapper">
  <ng-container *ngTemplateOutlet="util.isMobile() ? carouselRef: glideRef">
  </ng-container>
</div>

<ng-template #glideRef>
  <ngx-glide [showArrows]="true" [perView]="util.isMobile() ? 1.6: 4.2" type="slider" [rewind]="true" [bound]="true" [perTouch]="1" [breakpoints]="breakpoints" [showBullets]="false" [keyboard]="false" [gap]="20" arrowLeftLabel="" arrowRightLabel="">
    <div class="benefit-item" *ngFor="let item of benefits">
      <ng-container *ngTemplateOutlet="contentRef; context: {item: item}"></ng-container>
    </div>
  </ngx-glide>
</ng-template>

<ng-template #contentRef let-item="item">
  <div class="header">
    <img [src]="item?.info_1" alt="hf benefits images" />
  </div>
  <div class="content">
    <div class="title" [innerHTML]="item?.info_2">
    </div>
    <div class="desc" [innerHTML]="item?.info_3">
    </div>
  </div>
</ng-template>

<ng-template #carouselRef>
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <ng-container *ngFor="let item of benefits; index as i">
          <div class="swiper-slide benefit-item">
            <ng-container *ngTemplateOutlet="contentRef; context: {item: item}"></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
</ng-template>